<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sjNUGz/image/Cover.jpg?1720819951511" alt="This image is the cover for the book The Hiccuppy Puppy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Hiccuppy Puppy
      </h1>
      <p class="bookDescription body article font2">
        <p>Danger, excitement, thrills, spills, and chills! Await our puppy hero today. Hiccup! Hiccup! Hiccup? What strange sounds were coming from this poor unfortunate dog? And why won’t they stop? This was not the ordinary day this puppy had planned. Join this amazing doggy on an incredible adventure as their day goes from bad to worse and a cure is sought after from everywhere and anywhere. Will this day ever end? Will this puppy get the help they need? Will they get the peace and quiet they long for? As one calamity leads to another and another, there’s only one way to find out… Hiccup! Hiccup! Hiccup!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin Payne
      </h2>
      
      <p class="authorDescription body article">Colin Payne is a postman from Bristol, where he has lived for most of his life. He has two children of a bothersome age and a partner whose age shall not be mentioned.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ac0f596